export default {
  title: 'Launchpad',
  valueChainAssessment: 'Value Chain Assessment',
  materialityAssessment: 'Materiality Assessment',
  settings: 'Settings',
};
